<template>
<v-dialog v-model="dialog" max-width="800px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>Course Transfer</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<Preloader text="Loading" v-if="loading" />
      <v-row v-if="!loading && course">
        <v-col cols="12" md="8">
          <v-text-field
						v-model="course.title"
						prepend-icon="mdi-book"
						label="Current Course"
						readonly>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
						v-model="course.shortTitle"
						prepend-icon="mdi-book"
            label="Code"
						readonly>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="!loading">
        <v-col cols="12" md="4">
          <v-select
            v-model="selectedCourseType"
            @change="getCourses(true, true)"
            :items="courseTypes"
            item-text="title"
            item-value="id"
            label="Type">
          </v-select>
        </v-col>

        <v-col cols="12" md="8">
          <v-select
            v-model="selectedCourse"
            :items="courses"
            item-text="title"
            item-value="id"
            label="New Course">
          </v-select>
        </v-col>
      </v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn 
				color="primary"
        :disabled="!selectedCourse || loading"
				@click="transfer()">
				Transfer
			</v-btn>
			<v-btn 
				@click="dialog = false">
				Close
			</v-btn>
		</v-card-actions>
  </v-card>
	
</v-dialog> 
</template>
<script>
import Api from '../../services/api'
import CourseMixin from '../../mixins/course.mixin'
// import Auth from '../../services/auth'
// import Constants from '../../services/constants'
import Notify from '../../services/notify'
import Preloader from '../main/Preloader'

export default {
  name: 'ApprovalForm',
  mixins: [ CourseMixin ],
  components: { Preloader },
  data() {
    return {
      loading: false,
      dialog: false,
      registration: null, 
      course: null,
    }
  },
  mounted() {
    this.refreshCourses();
  },
  methods: {
    init(registrationId) {
      this.dialog = true;
      this.loading = true;
      Api.registration.get(registrationId)
        .then((response) => {
          this.registration = response.data;
          Api.course.get(this.registration.primaryCourseId)
            .then((response) => {
              this.course = response.data;
            })
            .finally(() => { this.loading = false; });
        })
        .catch(() => { Notify.error.oops(); })
        
    },
    
    transfer() {
      if(this.registration.enrollDateTime) {
        Notify.prompt('This Student Is  Already Enrolled', 'Enter password to transfer student')
          .then((password) => {
            console.log(password);
            if(password == 'gwapa') {
              this.doTransfer();
            } else {
              Notify.error.invalidPassword();
              this.dialog = false;
            }
          });
      } else {
        Notify.confirm('Transfer Registration?', 'Action can be undone.')
          .then(() => {
            this.doTransfer();
          });
      }
    },

    doTransfer() {
      this.registration.primaryCourseId = this.selectedCourse;
      Api.registration.transfer(this.registration.id, this.selectedCourse)
        .then(() => {
          Notify.success.itemUpdated();
          this.$emit('registration-transferred')
          this.dialog = false;
        })
        .catch(() => { Notify.error.updateFailed() });
    },

    refreshCourses() {
      this.getCourseTypes();
      this.getCourses(false, true);
    },

  }
}
</script>